import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


import * as $ from 'jquery';

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent implements OnInit {
    captchaResponse: string = '';
    public apiInputs = { "project_id": "", "supplier_id": "", "token": "", "ip_address": "", "form_data": "", "udid": "", "question_id": 0 };
    public feedbackSet: any = [];
    public feedbackQuestions: any = [];
    public currentIndex: number = 1;
    public totalQuestion: number = 7;
    public apiRequestStatus: boolean = false;
    public currentCustomer: any = {};
    public client: any = '';
    public store: any = '';
    public token: any = '';
    public logoimage = '';
    public clientlogo = '';
    public todate = new Date();
    public embeded_url: any = "";
    public is_boat: any;
    public nextques: any;
    public question_id: any;
    public gifcaptcha = '';
    public image_url=this.apiService.imageurl;
    public projectid: any = '';
    public supplierid: any = '';
    public is_text_analyzer = 0;




    constructor(
        public apiService: ApiService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService,
        public sanitized: DomSanitizer,


    ) {
        this.activatedRoute.queryParams.subscribe((params: Params) => {


            if (typeof params.projectid != 'undefined' && params.projectid != '' && params.projectid != null &&
                typeof params.supplierid != 'undefined' && params.supplierid != '' && params.supplierid != null
            ) {
                this.projectid = params.projectid;
                this.supplierid = params.supplierid;
                this.client = params.projectid;
                this.store = params.supplierid;
                this.token = params?.token;
                this.gifcaptcha = params?.gif_captcha;
                this.apiInputs.project_id = this.client;
                this.apiInputs.supplier_id = this.store;
                this.apiInputs.token = this.token;
                this.apiInputs.udid = params.udid;

            }
            else {
                // this.router.navigate(['survey/not-found']);
            }
        });

    }
    siteKey: string = "6LeNpgAsAAAAAEKVdIyZ9Btg8ZUlymP73udCVBiw";
    secretKey: string = "6LeNpgAsAAAAAEKVdIyZ9Btg8ZUlymP73udCVBiw";

    ngOnInit(): void {

        this.getCustomer();
        if (this.gifcaptcha == 'yes') {
            this.get_captcha_list();
        } else {
            this.get_captcha_list();
            
        }



    }
    handleCaptchaResponse(response: string): void {
        this.captchaResponse = response;
        console.log('this.captchaResponse', this.captchaResponse);
    }

    async getCustomer() {
        var currentCustomerTemp: any = await this.localStorageService.getItem("currentCustomer");
        this.currentCustomer = JSON.parse(currentCustomerTemp);
        console.log("this.currentCustomer", this.currentCustomer);
    }

    showLoader() {
        $("#loader_form").show();
    }

    hideLoader() {
        $("#loader_form").hide();
    }

    submit() {
       
        if (this.is_boat == 1) {
            if (this.captchaResponse == '') {
                this.apiService.showToast("Please select recaptcha value.", 2000);
                return false;
            }
        }
        if (typeof this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data == 'undefined' ||
            this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data == null ||
            this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data == '') {
            this.apiService.showToast("This is required field.", 2000);
            return false;
        }

        this.apiInputs.form_data = JSON.stringify(this.feedbackQuestions);
        var texttype = this.feedbackQuestions[(this.currentIndex - 1)]?.text_type;
        var title = this.feedbackQuestions[(this.currentIndex - 1)]?.title;
        if (texttype == 1) {
            var ansdata = this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data;
            var len = ansdata.toString().length;
            var eml = ansdata.includes("@");
            var eml2 = ansdata.includes(".");

            if (eml == '' || eml2 == '') {
                this.apiService.showToast("Please enter valid " + title + " id.", 2000);
                return false;
            }
        }

        if (texttype == 2) {
            var ansdata = this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data;
            var regexStr = '^[0-9]*$';
            var len = ansdata.toString().length;
            var req = this.feedbackQuestions[(this.currentIndex - 1)]?.text_value;
            const myValue: number = parseInt(ansdata);

            if (this.isNumber(myValue)) {

            } else {
                this.apiService.showToast("Please enter valid " + title + " number.", 2000);
                return false;
            }
            if (len < req) {
                this.apiService.showToast("Please enter minimum " + req + " digit in number.", 2000);
                return false;
            }

        }
        console.log('this.apiInputs', this.apiInputs.form_data);

        this.showLoader();
       
            this.apiService.postApi(this.apiInputs, 'user/submit_captcha').subscribe((result) => {
                this.hideLoader();
                this.gifcaptcha = 'no';
                var result = JSON.parse(this.apiService.decode(result.successdata));
                if (result.status == 1 && result.is_text_analyzer == 0) {
                    
                    decodeURI(result.url);
                    window.location = result.url;
                } else if (result.status == 11 && result.is_text_analyzer == 0) {
                    decodeURI(result.url);
                    this.embeded_url = this.sanitized.bypassSecurityTrustResourceUrl(result.url);

                } else if (result.status == 13 && result.is_text_analyzer == 1) {
                    this.router.navigate(
                        ['survey/textanalyzer'],
                        { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token} }
                    );
                } else if (result.status == 11 && result.is_text_analyzer == 1) {
                    this.router.navigate(
                        ['survey/textanalyzer'],
                        { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token} }
                    );
                } else if (result.status == 1 && result.is_text_analyzer == 1) {
                    this.router.navigate(
                        ['survey/textanalyzer'],
                        { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token} }
                    );
                } else {
                    this.router.navigate(
                        ['survey/survey'],
                        { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token} }
                    );
                }
            }, (err) => {
    
                console.log("user/getProjectQuestion", JSON.stringify(err));
            });   
        

    }

    parseInt(val: any): number {
        return parseInt(val) || 0;
    }

    setAnswer(_this: any, index = 0, value: any, extra = null) {
        this.feedbackQuestions[index].ans_data = value;
        console.log("answerSetsTemp[index]->" + index, this.feedbackQuestions[index]);
    }

    setMultiAnswer(_this: any, index = 0, value: any, extra = null) {
        this.feedbackQuestions[index].ans_data = value;
        console.log("answerSetsTemp[index]->" + index, this.feedbackQuestions[index]);
    }

    isNumber(value: any): boolean {
        console.log(value);
        return typeof value === 'number' && !isNaN(value);
    }

    get_captcha_list(data = 0) {

        this.showLoader();
        if (data != 0) {
            this.apiInputs.question_id = data;
        }

        this.apiService.postApi(this.apiInputs, 'user/getCaptchaQuestion').subscribe((result) => {
            this.hideLoader();
            var result = JSON.parse(this.apiService.decode(result.successdata));
            if (result.status) {
                this.apiRequestStatus = true;
                console.log('feedback_list result', result);

                //this.feedbackSet = result?.data?.feedback_set;
                this.feedbackQuestions = result?.data;
                this.totalQuestion = this.feedbackQuestions.length;
                this.is_boat = result.is_boat;
                // this.logoimage  = result.client_logo;
                //this.clientlogo = this.apiService.clientlogourl;

            }
            else {
                this.router.navigate(['survey/not-found']);
            }

        }, (err) => {
            this.hideLoader();
            this.router.navigate(['not-found']);
            console.log("user/getProjectQuestion", JSON.stringify(err));
        });
    }
}
